"use client";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "antd";
import Image from "next/image";
import { Link } from "@/navigation";
import { useTranslations } from "next-intl";

const PageList = () => {
	const t = useTranslations();
	const data = [
		{
			iconWidth: 77,
			iconHeight: 78,
			icon: "/image/resource/Blog.png",
			name: t("resource.Blog"),
			href: "/blog",
		},
		{
			iconWidth: 69,
			iconHeight: 78,
			icon: "/image/resource/WhitePapers.png",
			name: t("resource.WhitePapers"),
			href: "/white-papers",
		},
		{
			iconWidth: 78,
			iconHeight: 76,
			icon: "/image/resource/Cases.png",
			name: t("resource.Cases"),
			href: "/products",
		},
		{
			iconWidth: 77,
			iconHeight: 78,
			icon: "/image/resource/News.png",
			name: t("resource.News"),
			href: "/blog",
		},
		{
			iconWidth: 78,
			iconHeight: 78,
			icon: "/image/resource/FAQ.png",
			name: t("resource.FAQ"),
			href: "/FAQ",
		},
	];

	return (
		<div className="bg-white pt-16 max-md:pt-8">
			<div className="container">
				<div className="grid grid-cols-5 gap-8 max-md:grid-cols-2">
					{data.map((item: any, index: number) => {
						return (
							<Link
								className="flex flex-1 flex-col items-center text-[#212121] hover:text-[#818181]"
								href={item.href}
								key={index}
							>
								<Image width={item.iconWidth} height={item.iconHeight} src={item.icon} alt="" />
								<div className="mt-4 text-base font-bold">{item.name}</div>
							</Link>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default PageList;
